// extracted by mini-css-extract-plugin
export default {"skipdatecontain":"yX","skip_info":"zX","skipped":"AX","modify_order":"BX","cancel_subscription_btn":"CX","byb":"EX","modify_order_outer":"FX","byb_edit_btn":"GX","modify_order_item":"HX","cancel_copy_wrapper":"IX","cancelled_copy":"JX"};
    if(module.hot) {
      // 1730991511732
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  